import { User } from '../slices/auth';
import { GRAPH_SCOPES, useGraph } from '../utils/useGraph';

export const GetProfilePicture = (currentUser: User) => {
  return useGraph(
    async (graph) => {
      let photoUrl = '';
      try {
        const photo = await graph
          .api(`/users/${currentUser.microsoftUserId}/photo/$value`)
          .get();
        photoUrl = URL.createObjectURL(photo);
      } catch (error) {
        // Could not fetch photo from user's profile, return empty string as placeholder.
        console.log(error);
      }
      return photoUrl;
    },
    { scope: GRAPH_SCOPES, auto: true },
  );
};
